<template>
  <TextInputGroup :id="componentId"
                  v-model="searchTerm"
                  :placeholder="placeholder"
                  :size="size"
                  class="search-input flex-nowrap"
                  input-classes="d-inline-block"
                  name="search"
                  type="text"
                  @update="emitSearchValue">
    <template #prependText>
      <Icon :title="tr('common.SEARCH')"
            class="mx-auto"
            name="search"></Icon>
    </template>
    <template #append>
      <ButtonIconOnly :title="tr('javascript.TX_REMOVE')"
                      :variant="BootstrapVariant.SECONDARY"
                      icon-name="cross2"
                      @click="clear">
      </ButtonIconOnly>
    </template>
  </TextInputGroup>
</template>

<script>
  import { v1 as uuid } from 'uuid';
  import { translator } from '~/zf/frontend/common/mixins';
  import BootstrapVariant from '~/zf/frontend/vendor/bootstrap/BootstrapVariant';
  import ButtonIconOnly from '../layout/ButtonIconOnly.vue';
  import Icon from '../layout/Icon.vue';
  import TextInputGroup from './TextInputGroup.vue';

  export default {
    name: 'SearchInput',
    compatConfig: {
      MODE: 3,
    },
    components: {
      ButtonIconOnly,
      Icon,
      TextInputGroup,
    },
    mixins: [
      translator,
    ],
    props: {
      placeholder: String,
      componentId: {
        type: String,
        required: false,
        default() {
          return uuid();
        },
      },
      size: {
        default: BootstrapVariant.SMALL,
      },
    },
    emits: ['update'],
    data() {
      return {
        searchTerm: '',
        BootstrapVariant,
      };
    },
    methods: {
      getSearchTerm() {
        return this.searchTerm;
      },
      emitSearchValue(searchValue) {
        this.$emit('update', searchValue);
      },
      clear() {
        this.searchTerm = '';
        this.emitSearchValue(this.searchTerm);
      },
      setSearchTerm(search) {
        this.searchTerm = search;
      },
    },
  };
</script>
